import { useCallback, useEffect, useState } from "react";
import { usePolling } from "@/hooks/usePolling";

// Loads the Command Centre feed and keeps it fresh at the server's refresh interval.
// On failure the last good figures stay on screen and `error` holds the HTTP status (or "network").
export function useCommandFeed(fetcher) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const load = useCallback(() => fetcher()
    .then(({ data: d }) => { setData(d); setError(null); })
    .catch((e) => setError(e?.response?.status || "network")), [fetcher]);
  useEffect(() => { load(); }, [load]);
  usePolling(load, (data?.refresh_s || 30) * 1000);
  return { data, error, reload: load };
}
